import locale from "localization";

export const vehicleColumns = [
  { key: "plateNumber", text: locale.plateNumber, width: "25%" },
  { key: "model", text: locale.model, width: "15%" },
  { key: "remarks", text: locale.remarks, width: "15%" },
  { key: "status", text: locale.status, width: "40%" },
  { key: "options", text: "", width: "5%" },
];
